"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Container = function (props) {
    var className = props.className, children = props.children;
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col items-center w-full", children: (0, jsx_runtime_1.jsx)("div", { className: "\n        w-full px-4 \n        min-w-phone\n        max-w-phone \n        md:max-w-tablet \n        lg:max-w-laptop \n        xl:max-w-laptop \n        ".concat(className), children: children }) }));
};
exports.Container = Container;
